import axiosInstance from '../axiosInceptor';

//Get Order By id
export const requestOrderById = (orderGuid: string) => {
  try {
    const url = process.env.REACT_APP_OLO_API || '';
    return axiosInstance
      .get(url + `/orders/${orderGuid}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  } catch (error) {
    throw error;
  }
};
